import React from 'react';
import styles from './styles.module.css';
import ModuleEmptyState from '../moduleCard/ModuleEmptyState';
import AccessibilityOutlinedIcon from '@mui/icons-material/AccessibilityOutlined';
import { BODY_VIEW_OPTIONS } from '../../../../components/bodySilhouette/bodyRegions';
import { hasIntensity, markerTitle } from './bodyMapMarkers';

const viewLabel = (view) => (BODY_VIEW_OPTIONS.find((item) => item.key === view) || {}).label || view;

/** Valor e barra curta da intensidade, na cor do tipo. */
const Intensity = ({ marker }) => (
  <span className={styles.intensity} aria-label={`Intensidade ${marker.intensity} de 10`}>
    {marker.intensity}/10
    <span className={styles.intensityBar}>
      <span
        className={`${styles.intensityFill} ${styles[`type_${marker.type}`] || ''}`}
        style={{ width: `${(Number(marker.intensity) / 10) * 100}%` }}
      />
    </span>
  </span>
);

/**
 * Lista dos marcadores do atendimento (todas as vistas), só leitura: região,
 * intensidade e nota (o tipo é a cor do número). Clicar chama `onSelect`, que
 * destaca o marcador na figura e, com `enabled`, abre o popup de edição.
 * `hoverIndex`/`onHover` sincronizam o destaque com o número na figura.
 */
const BodyMapMarkerList = ({ markers, view, selectedIndex, hoverIndex, enabled, onSelect, onHover }) => {
  if (markers.length === 0) {
    return (
      <ModuleEmptyState
        icon={<AccessibilityOutlinedIcon />}
        text={enabled ? 'Nenhum marcador. Clique na figura ou escolha uma região.' : 'Nenhum marcador neste atendimento.'}
      />
    );
  }

  return (
    <div className={styles.list}>
      {markers.map((marker, index) => (
        <div
          key={index}
          className={[
            styles.marker,
            styles[`accent_${marker.type}`] || '',
            selectedIndex === index ? styles.markerSelected : '',
            hoverIndex === index && selectedIndex !== index ? styles.markerHover : '',
          ].join(' ')}
          onClick={() => onSelect(index)}
          onKeyDown={(event) => { if (event.key === 'Enter' || event.key === ' ') onSelect(index); }}
          onMouseEnter={() => onHover && onHover(index)}
          onMouseLeave={() => onHover && onHover(null)}
          role="button"
          tabIndex={0}
        >
          <div className={styles.markerHead}>
            <span className={`${styles.number} ${styles[`type_${marker.type}`] || ''}`}>{index + 1}</span>
            <div className={styles.markerText}>
              <span className={styles.title}>{markerTitle(marker)}</span>
              {marker.view !== view && <span className={styles.meta}><span className={styles.viewTag}>{viewLabel(marker.view)}</span></span>}
            </div>
            {hasIntensity(marker) && <Intensity marker={marker} />}
          </div>
          {marker.note && <span className={styles.note}>{marker.note}</span>}
        </div>
      ))}
    </div>
  );
};

export default BodyMapMarkerList;
